// extracted by css-extract-rspack-plugin
export default {"emoji":"yYjgsj6LRk4br4wv","compactEmoji":"FVMO1UfcEHsCfZWM"};